"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_OPENID_CHECK_SESSION_ERROR = exports.EVENT_OPENID_SESSION_UNCHANGED = exports.EVENT_OPENID_SESSION_CHANGED = exports.EVENT_OPENID_METADATA_FETCH_ERROR = exports.EVENT_AUTH_RENEW_SUCCESS = exports.EVENT_AUTH_RENEW_ERROR = exports.EVENT_AUTH_EXPIRED = exports.EVENT_AUTH_DISCARDED = void 0;
/**
 * The authorization token has been discarded.
 */
exports.EVENT_AUTH_DISCARDED = 'authorizationDiscarded';
/**
 * The authorization token has expired.
 */
exports.EVENT_AUTH_EXPIRED = 'authorizationExpired';
/**
 * Error has occurred while renewing the token.
 */
exports.EVENT_AUTH_RENEW_ERROR = 'renewAuthorizationError';
/**
 * The current token has been successfully renewed.
 */
exports.EVENT_AUTH_RENEW_SUCCESS = 'renewAuthorizationSuccess';
/**
 * Error has occurred while fetching the OpenID Metadata.
 */
exports.EVENT_OPENID_METADATA_FETCH_ERROR = 'OpenIDMetadataFetchError';
/**
 * Indicates that the OpenID session has changed.
 */
exports.EVENT_OPENID_SESSION_CHANGED = 'OpenIDCheckSessionChanged';
/**
 * Indicates that the OpenID session has not changed.
 */
exports.EVENT_OPENID_SESSION_UNCHANGED = 'OpenIDCheckSessionUnchanged';
/**
 * Error has occurred while fetching the OpenID Metadata.
 */
exports.EVENT_OPENID_CHECK_SESSION_ERROR = 'OpenIDCheckSessionError';
//# sourceMappingURL=SGWTConnectEventList.js.map